const icons = {};

import f10Icon12Grid from "./svg/f10-icon-1-2-grid.svg?raw";
icons["f10-icon-1-2-grid"] = f10Icon12Grid;

import f10Icon22Grid from "./svg/f10-icon-2-2-grid.svg?raw";
icons["f10-icon-2-2-grid"] = f10Icon22Grid;

import f10Icon33Grid from "./svg/f10-icon-3-3-grid.svg?raw";
icons["f10-icon-3-3-grid"] = f10Icon33Grid;

import f10IconAirplane from "./svg/f10-icon-airplane.svg?raw";
icons["f10-icon-airplane"] = f10IconAirplane;

import f10IconAndroid from "./svg/f10-icon-android.svg?raw";
icons["f10-icon-android"] = f10IconAndroid;

import f10IconApple from "./svg/f10-icon-apple.svg?raw";
icons["f10-icon-apple"] = f10IconApple;

import f10IconArrowCurly from "./svg/f10-icon-arrow-curly.svg?raw";
icons["f10-icon-arrow-curly"] = f10IconArrowCurly;

import f10IconArrowDown from "./svg/f10-icon-arrow-down.svg?raw";
icons["f10-icon-arrow-down"] = f10IconArrowDown;

import f10IconArrowLeft from "./svg/f10-icon-arrow-left.svg?raw";
icons["f10-icon-arrow-left"] = f10IconArrowLeft;

import f10IconArrowRight from "./svg/f10-icon-arrow-right.svg?raw";
icons["f10-icon-arrow-right"] = f10IconArrowRight;

import f10IconArrowUp from "./svg/f10-icon-arrow-up.svg?raw";
icons["f10-icon-arrow-up"] = f10IconArrowUp;

import f10IconAsterisk from "./svg/f10-icon-asterisk.svg?raw";
icons["f10-icon-asterisk"] = f10IconAsterisk;

import f10IconBlackAndWhite from "./svg/f10-icon-black-and-white.svg?raw";
icons["f10-icon-black-and-white"] = f10IconBlackAndWhite;

import f10IconBrightness from "./svg/f10-icon-brightness.svg?raw";
icons["f10-icon-brightness"] = f10IconBrightness;

import f10IconCaretDown from "./svg/f10-icon-caret-down.svg?raw";
icons["f10-icon-caret-down"] = f10IconCaretDown;

import f10IconCaretLeft from "./svg/f10-icon-caret-left.svg?raw";
icons["f10-icon-caret-left"] = f10IconCaretLeft;

import f10IconCaretRight from "./svg/f10-icon-caret-right.svg?raw";
icons["f10-icon-caret-right"] = f10IconCaretRight;

import f10IconCaretUp from "./svg/f10-icon-caret-up.svg?raw";
icons["f10-icon-caret-up"] = f10IconCaretUp;

import f10IconCart from "./svg/f10-icon-cart.svg?raw";
icons["f10-icon-cart"] = f10IconCart;

import f10IconCheck from "./svg/f10-icon-check.svg?raw";
icons["f10-icon-check"] = f10IconCheck;

import f10IconClock from "./svg/f10-icon-clock.svg?raw";
icons["f10-icon-clock"] = f10IconClock;

import f10IconClose from "./svg/f10-icon-close.svg?raw";
icons["f10-icon-close"] = f10IconClose;

import f10IconCog from "./svg/f10-icon-cog.svg?raw";
icons["f10-icon-cog"] = f10IconCog;

import f10IconCopy from "./svg/f10-icon-copy.svg?raw";
icons["f10-icon-copy"] = f10IconCopy;

import f10IconCrop from "./svg/f10-icon-crop.svg?raw";
icons["f10-icon-crop"] = f10IconCrop;

import f10IconDate from "./svg/f10-icon-date.svg?raw";
icons["f10-icon-date"] = f10IconDate;

import f10IconDesktop from "./svg/f10-icon-desktop.svg?raw";
icons["f10-icon-desktop"] = f10IconDesktop;

import f10IconDoubleCaretDown from "./svg/f10-icon-double-caret-down.svg?raw";
icons["f10-icon-double-caret-down"] = f10IconDoubleCaretDown;

import f10IconDoubleCaretLeft from "./svg/f10-icon-double-caret-left.svg?raw";
icons["f10-icon-double-caret-left"] = f10IconDoubleCaretLeft;

import f10IconDoubleCaretRight from "./svg/f10-icon-double-caret-right.svg?raw";
icons["f10-icon-double-caret-right"] = f10IconDoubleCaretRight;

import f10IconDoubleCaretUp from "./svg/f10-icon-double-caret-up.svg?raw";
icons["f10-icon-double-caret-up"] = f10IconDoubleCaretUp;

import f10IconDownloadDone from "./svg/f10-icon-download-done.svg?raw";
icons["f10-icon-download-done"] = f10IconDownloadDone;

import f10IconDownload from "./svg/f10-icon-download.svg?raw";
icons["f10-icon-download"] = f10IconDownload;

import f10IconDropbox from "./svg/f10-icon-dropbox.svg?raw";
icons["f10-icon-dropbox"] = f10IconDropbox;

import f10IconDuplicateMultiple from "./svg/f10-icon-duplicate-multiple.svg?raw";
icons["f10-icon-duplicate-multiple"] = f10IconDuplicateMultiple;

import f10IconEdit from "./svg/f10-icon-edit.svg?raw";
icons["f10-icon-edit"] = f10IconEdit;

import f10IconEquals from "./svg/f10-icon-equals.svg?raw";
icons["f10-icon-equals"] = f10IconEquals;

import f10IconExclamationTriangle from "./svg/f10-icon-exclamation-triangle.svg?raw";
icons["f10-icon-exclamation-triangle"] = f10IconExclamationTriangle;

import f10IconExclamation from "./svg/f10-icon-exclamation.svg?raw";
icons["f10-icon-exclamation"] = f10IconExclamation;

import f10IconExit from "./svg/f10-icon-exit.svg?raw";
icons["f10-icon-exit"] = f10IconExit;

import f10IconExpand from "./svg/f10-icon-expand.svg?raw";
icons["f10-icon-expand"] = f10IconExpand;

import f10IconEye from "./svg/f10-icon-eye.svg?raw";
icons["f10-icon-eye"] = f10IconEye;

import f10IconFacebook from "./svg/f10-icon-facebook.svg?raw";
icons["f10-icon-facebook"] = f10IconFacebook;

import f10IconFloat from "./svg/f10-icon-float.svg?raw";
icons["f10-icon-float"] = f10IconFloat;

import f10IconFrame8x10 from "./svg/f10-icon-frame-8-10.svg?raw";
icons["f10-icon-frame-8-10"] = f10IconFrame8x10;

import f10IconFrame10x8 from "./svg/f10-icon-frame-10-8.svg?raw";
icons["f10-icon-frame-10-8"] = f10IconFrame10x8;

import f10IconFrame10x12 from "./svg/f10-icon-frame-10-12.svg?raw";
icons["f10-icon-frame-10-12"] = f10IconFrame10x12;

import f10IconFrame11x11 from "./svg/f10-icon-frame-11-11.svg?raw";
icons["f10-icon-frame-11-11"] = f10IconFrame11x11;

import f10IconFrame12x10 from "./svg/f10-icon-frame-12-10.svg?raw";
icons["f10-icon-frame-12-10"] = f10IconFrame12x10;

import f10IconFrame14x16 from "./svg/f10-icon-frame-14-16.svg?raw";
icons["f10-icon-frame-14-16"] = f10IconFrame14x16;

import f10IconFrame16x14 from "./svg/f10-icon-frame-16-14.svg?raw";
icons["f10-icon-frame-16-14"] = f10IconFrame16x14;

import f10IconGalleryWall from "./svg/f10-icon-gallery-walls.svg?raw";
icons["f10-icon-gallery-walls"] = f10IconGalleryWall;

import f10IconGift from "./svg/f10-icon-gift.svg?raw";
icons["f10-icon-gift"] = f10IconGift;

import f10IconGiftcard from "./svg/f10-icon-giftcard.svg?raw";
icons["f10-icon-giftcard"] = f10IconGiftcard;

import f10IconGooglePhotos from "./svg/f10-icon-google-photos.svg?raw";
icons["f10-icon-google-photos"] = f10IconGooglePhotos;

import f10IconHanging from "./svg/f10-icon-hanging.svg?raw";
icons["f10-icon-hanging"] = f10IconHanging;

import f10IconHeart from "./svg/f10-icon-heart.svg?raw";
icons["f10-icon-heart"] = f10IconHeart;

import f10IconHelp from "./svg/f10-icon-help.svg?raw";
icons["f10-icon-help"] = f10IconHelp;

import f10IconImageSet from "./svg/f10-icon-image-set.svg?raw";
icons["f10-icon-image-set"] = f10IconImageSet;

import f10IconImage from "./svg/f10-icon-image.svg?raw";
icons["f10-icon-image"] = f10IconImage;

import f10IconInfo from "./svg/f10-icon-info.svg?raw";
icons["f10-icon-info"] = f10IconInfo;

import f10IconInstagram from "./svg/f10-icon-instagram.svg?raw";
icons["f10-icon-instagram"] = f10IconInstagram;

import f10IconLaptop from "./svg/f10-icon-laptop.svg?raw";
icons["f10-icon-laptop"] = f10IconLaptop;

import f10IconLightning from "./svg/f10-icon-lightning.svg?raw";
icons["f10-icon-lightning"] = f10IconLightning;

import f10IconLinkBroken from "./svg/f10-icon-link-broken.svg?raw";
icons["f10-icon-link-broken"] = f10IconLinkBroken;

import f10IconLink from "./svg/f10-icon-link.svg?raw";
icons["f10-icon-link"] = f10IconLink;

import f10IconLinkedin from "./svg/f10-icon-linkedin.svg?raw";
icons["f10-icon-linkedin"] = f10IconLinkedin;

import f10IconLockUnlocked from "./svg/f10-icon-lock-unlocked.svg?raw";
icons["f10-icon-lock-unlocked"] = f10IconLockUnlocked;

import f10IconLock from "./svg/f10-icon-lock.svg?raw";
icons["f10-icon-lock"] = f10IconLock;

import f10IconMatStandard from "./svg/f10-icon-mat-standard.svg?raw";
icons["f10-icon-mat-standard"] = f10IconMatStandard;

import f10IconMatThin from "./svg/f10-icon-mat-thin.svg?raw";
icons["f10-icon-mat-thin"] = f10IconMatThin;

import f10IconMatWeighted from "./svg/f10-icon-mat-weighted.svg?raw";
icons["f10-icon-mat-weighted"] = f10IconMatWeighted;

import f10IconMatWide from "./svg/f10-icon-mat-wide.svg?raw";
icons["f10-icon-mat-wide"] = f10IconMatWide;

import f10IconMat from "./svg/f10-icon-mat.svg?raw";
icons["f10-icon-mat"] = f10IconMat;

import f10IconMenu from "./svg/f10-icon-menu.svg?raw";
icons["f10-icon-menu"] = f10IconMenu;

import f10IconMessenger from "./svg/f10-icon-messenger.svg?raw";
icons["f10-icon-messenger"] = f10IconMessenger;

import f10IconMinus from "./svg/f10-icon-minus.svg?raw";
icons["f10-icon-minus"] = f10IconMinus;

import f10IconMobile from "./svg/f10-icon-mobile.svg?raw";
icons["f10-icon-mobile"] = f10IconMobile;

import f10IconMore from "./svg/f10-icon-more.svg?raw";
icons["f10-icon-more"] = f10IconMore;

import f10IconMoulding from "./svg/f10-icon-moulding.svg?raw";
icons["f10-icon-moulding"] = f10IconMoulding;

import f10IconMove from "./svg/f10-icon-move.svg?raw";
icons["f10-icon-move"] = f10IconMove;

import f10IconNotes from "./svg/f10-icon-notes.svg?raw";
icons["f10-icon-notes"] = f10IconNotes;

import f10IconPause from "./svg/f10-icon-pause.svg?raw";
icons["f10-icon-pause"] = f10IconPause;

import f10IconPen from "./svg/f10-icon-pen.svg?raw";
icons["f10-icon-pen"] = f10IconPen;

import f10IconPersonalize from "./svg/f10-icon-personalize.svg?raw";
icons["f10-icon-personalize"] = f10IconPersonalize;

import f10IconPin from "./svg/f10-icon-pin.svg?raw";
icons["f10-icon-pin"] = f10IconPin;

import f10IconPinterest from "./svg/f10-icon-pinterest.svg?raw";
icons["f10-icon-pinterest"] = f10IconPinterest;

import f10IconPlay from "./svg/f10-icon-play.svg?raw";
icons["f10-icon-play"] = f10IconPlay;

import f10IconPlus from "./svg/f10-icon-plus.svg?raw";
icons["f10-icon-plus"] = f10IconPlus;

import f10IconPocket from "./svg/f10-icon-pocket.svg?raw";
icons["f10-icon-pocket"] = f10IconPocket;

icons["f10-icon-preset-5-7"] = f10IconPreset_5_7;
import f10IconPreset_5_7 from "./svg/f10-icon-preset-5-7.svg?raw";

icons["f10-icon-preset-7-5"] = f10IconPreset_7_5;
import f10IconPreset_7_5 from "./svg/f10-icon-preset-7-5.svg?raw";

icons["f10-icon-preset-8-10"] = f10IconPreset_8_10;
import f10IconPreset_8_10 from "./svg/f10-icon-preset-8-10.svg?raw";

icons["f10-icon-preset-10-8"] = f10IconPreset_10_8;
import f10IconPreset_10_8 from "./svg/f10-icon-preset-10-8.svg?raw";

icons["f10-icon-preset-11-14"] = f10IconPreset_11_14;
import f10IconPreset_11_14 from "./svg/f10-icon-preset-11-14.svg?raw";

icons["f10-icon-preset-14-11"] = f10IconPreset_14_11;
import f10IconPreset_14_11 from "./svg/f10-icon-preset-14-11.svg?raw";

import f10IconPrint from "./svg/f10-icon-print.svg?raw";
icons["f10-icon-print"] = f10IconPrint;

import f10IconQrCode from "./svg/f10-icon-qr-code.svg?raw";
icons["f10-icon-qr-code"] = f10IconQrCode;

import f10IconQuestion from "./svg/f10-icon-question.svg?raw";
icons["f10-icon-question"] = f10IconQuestion;

import f10IconRatio11 from "./svg/f10-icon-ratio-1-1.svg?raw";
icons["f10-icon-ratio-1-1"] = f10IconRatio11;

import f10IconRatio169 from "./svg/f10-icon-ratio-16-9.svg?raw";
icons["f10-icon-ratio-16-9"] = f10IconRatio169;

import f10IconRatio23 from "./svg/f10-icon-ratio-2-3.svg?raw";
icons["f10-icon-ratio-2-3"] = f10IconRatio23;

import f10IconRatio32 from "./svg/f10-icon-ratio-3-2.svg?raw";
icons["f10-icon-ratio-3-2"] = f10IconRatio32;

import f10IconRatio34 from "./svg/f10-icon-ratio-3-4.svg?raw";
icons["f10-icon-ratio-3-4"] = f10IconRatio34;

import f10IconRatio43 from "./svg/f10-icon-ratio-4-3.svg?raw";
icons["f10-icon-ratio-4-3"] = f10IconRatio43;

import f10IconRatio45 from "./svg/f10-icon-ratio-4-5.svg?raw";
icons["f10-icon-ratio-4-5"] = f10IconRatio45;

import f10IconRatio54 from "./svg/f10-icon-ratio-5-4.svg?raw";
icons["f10-icon-ratio-5-4"] = f10IconRatio54;

import f10IconRatio57 from "./svg/f10-icon-ratio-5-7.svg?raw";
icons["f10-icon-ratio-5-7"] = f10IconRatio57;

import f10IconRatio75 from "./svg/f10-icon-ratio-7-5.svg?raw";
icons["f10-icon-ratio-7-5"] = f10IconRatio75;

import f10IconRatio916 from "./svg/f10-icon-ratio-9-16.svg?raw";
icons["f10-icon-ratio-9-16"] = f10IconRatio916;

icons["f10-icon-ratio-11-14"] = f10IconRatio_11_14;
import f10IconRatio_11_14 from "./svg/f10-icon-ratio-11-14.svg?raw";

icons["f10-icon-ratio-14-11"] = f10IconRatio_14_11;
import f10IconRatio_14_11 from "./svg/f10-icon-ratio-14-11.svg?raw";

import f10IconRatioCustom from "./svg/f10-icon-ratio-custom.svg?raw";
icons["f10-icon-ratio-custom"] = f10IconRatioCustom;

icons["f10-icon-ratio-freeform"] = f10IconRatioFreeform;
import f10IconRatioFreeform from "./svg/f10-icon-ratio-freeform.svg?raw";

icons["f10-icon-ratio-square"] = f10IconRatioSquare;
import f10IconRatioSquare from "./svg/f10-icon-ratio-square.svg?raw";

import f10IconRotateClockwise from "./svg/f10-icon-rotate-clockwise.svg?raw";
icons["f10-icon-rotate-clockwise"] = f10IconRotateClockwise;

import f10IconRotateCounterclockwise from "./svg/f10-icon-rotate-counterclockwise.svg?raw";
icons["f10-icon-rotate-counterclockwise"] = f10IconRotateCounterclockwise;

import f10IconRotate from "./svg/f10-icon-rotate.svg?raw";
icons["f10-icon-rotate"] = f10IconRotate;

import f10IconRuler from "./svg/f10-icon-ruler.svg?raw";
icons["f10-icon-ruler"] = f10IconRuler;

import f10IconSale from "./svg/f10-icon-sale.svg?raw";
icons["f10-icon-sale"] = f10IconSale;

import f10IconSearch from "./svg/f10-icon-search.svg?raw";
icons["f10-icon-search"] = f10IconSearch;

import f10IconShare from "./svg/f10-icon-share.svg?raw";
icons["f10-icon-share"] = f10IconShare;

import f10IconShuffle from "./svg/f10-icon-shuffle.svg?raw";
icons["f10-icon-shuffle"] = f10IconShuffle;

import f10IconSmile from "./svg/f10-icon-smile.svg?raw";
icons["f10-icon-smile"] = f10IconSmile;

import f10IconSparkle from "./svg/f10-icon-sparkle.svg?raw";
icons["f10-icon-sparkle"] = f10IconSparkle;

import f10IconSpinner from "./svg/f10-icon-spinner.svg?raw";
icons["f10-icon-spinner"] = f10IconSpinner;

import f10IconStar from "./svg/f10-icon-star.svg?raw";
icons["f10-icon-star"] = f10IconStar;

import f10IconStore from "./svg/f10-icon-store.svg?raw";
icons["f10-icon-store"] = f10IconStore;

import f10IconSuitcase from "./svg/f10-icon-suitcase.svg?raw";
icons["f10-icon-suitcase"] = f10IconSuitcase;

import f10IconTextAlignCenter from "./svg/f10-icon-text-align-center.svg?raw";
icons["f10-icon-text-align-center"] = f10IconTextAlignCenter;

import f10IconTextAlignLeft from "./svg/f10-icon-text-align-left.svg?raw";
icons["f10-icon-text-align-left"] = f10IconTextAlignLeft;

import f10IconTextAlignRight from "./svg/f10-icon-text-align-right.svg?raw";
icons["f10-icon-text-align-right"] = f10IconTextAlignRight;

import f10IconTrash from "./svg/f10-icon-trash.svg?raw";
icons["f10-icon-trash"] = f10IconTrash;

import f10IconTruck from "./svg/f10-icon-truck.svg?raw";
icons["f10-icon-truck"] = f10IconTruck;

import f10IconTwitter from "./svg/f10-icon-twitter.svg?raw";
icons["f10-icon-twitter"] = f10IconTwitter;

import f10IconUpload from "./svg/f10-icon-upload.svg?raw";
icons["f10-icon-upload"] = f10IconUpload;

import f10IconUser from "./svg/f10-icon-user.svg?raw";
icons["f10-icon-user"] = f10IconUser;

import f10IconYoutube from "./svg/f10-icon-youtube.svg?raw";
icons["f10-icon-youtube"] = f10IconYoutube;

export default icons;
